export const SET_IS_LOADING = 'SCHEDULING_OTHERS/SET_IS_LOADING';
export const SET_SCHEDULING_OTHERS = 'SCHEDULING_OTHERS/SET_SCHEDULING_OTHERS';
export const CLEAR_SCHEDULING_OTHERS = 'SCHEDULING_OTHERS/CLEAR_SCHEDULING_OTHERS';